import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import { loadSalesPulse } from './loadSalesPulse';
import type { SalesPulseModel } from './types';

export function useSalesPulse(opts: {
  refreshToken?: number;
  connection: SellerConnection | null;
}) {
  const { refreshToken = 0, connection } = opts;
  const [model, setModel] = useState<SalesPulseModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const m = await loadSalesPulse({ connection });
      setModel(m);
      if (m.error) setError(m.error);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load 24h sales pulse');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
